import React from 'react';
import i18next from 'i18next';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import { css } from 'emotion';
import withDirection from '~/modules/core/utils/mediaHelpers/withDirection';
import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';

const Container = styled.div`
  display: block;
  width: 100%;
  & tr:nth-child(odd) {
    background: rgba(229,229,229,0.7);
  }
`;

const TableStyle = styled.table`
  width: 100%;
`;

const keyValueStyle = props => css`
  ${props.direction === 'rtl'
    ? css`
        text-align: right;
      `
    : css`
        text-align: left;
  `}
  padding-right: ${props.theme.new.spacer}px;
  padding-left: ${props.theme.new.spacer}px;
  font-size: ${props.theme.fonts.sizes.small}px;
  line-height: 2.14;
`;

const Key = withDirection(withMedia(styled.th`
  ${props => keyValueStyle(props)};
  width: ${props => (props.media.xsmall ? '105px' : '373px')};

  font-weight: ${props => props.theme.new.fonts.weights.semiBold};
  color: ${props => props.theme.colors.labels.important};
`));

const Value = withDirection(styled.td`
  ${props => keyValueStyle(props)};

  color: ${props => props.theme.colors.labels.subNormal};
`);

const Specifications = props => (
  <Container>
    <TableStyle>
      <tbody>
        {props.brand !== null && (
          <tr key="spec-brand">
            <Key key="key-brand">{i18next.t('ecommerceCoreUI:Product.sellingShops.brand')}</Key>
            <Value key="value-brand">{props.brand}</Value>
          </tr>
        )}
        {props.madeIn !== null && (
          <tr key="spec-madeIn">
            <Key key="key-madeIn">{i18next.t('ecommerceCoreUI:Product.sellingShops.madeIn')}</Key>
            <Value key="value-madeIn">{props.madeIn}</Value>
          </tr>
        )}
        {props.weight !== null && (
          <tr key="spec-madeIn">
            <Key key="key-madeIn">{i18next.t('ecommerceCoreUI:Product.sellingShops.weight')}</Key>
            <Value key="value-madeIn">{props.weight}</Value>
          </tr>
        )}
        {props.dimensions !== null && (
          <tr key="spec-madeIn">
            <Key key="key-madeIn">{i18next.t('ecommerceCoreUI:Product.sellingShops.dimensions')}</Key>
            <Value key="value-madeIn">{props.dimensions}</Value>
          </tr>
        )}
        {props.specifications
          && props.specifications.map(
            spec => spec.value && (
            <tr key={spec.id}>
              <Key key={`key-${spec.id}`}>{spec.presentation}</Key>
              <Value key={`value-${spec.id}`}>{spec.value}</Value>
            </tr>
            ),
          )}
      </tbody>
    </TableStyle>
  </Container>
);

Specifications.defaultProps = {
  brand: null,
  madeIn: null,
  weight: null,
  dimensions: null,
};

Specifications.propTypes = {
  brand: PropTypes.string,
  madeIn: PropTypes.string,
  weight: PropTypes.string,
  dimensions: PropTypes.string,
  specifications: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string,
      presentation: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default Specifications;
